import {
    apiRequest,
    presensiActive,
    presensiInactive,
    presensilistatasan
} from "../../../../../services/adapters/kepegawaian/presensiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", presensilistatasan, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", presensiInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", presensiActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository